module.exports = __webpack_public_path__ + "static/media/security-ico.6d16010d.svg";